module.exports = __webpack_public_path__ + "h5/img/live-logo.9a6ca4ce.gif";